import { EventEmitter, Injectable } from '@angular/core';
import { NavigationCancel, NavigationEnd, NavigationError, NavigationStart, Router } from '@angular/router';
import { Subscription } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class PageLoaderService {
  private pageEvent$ = new EventEmitter<boolean>();
  loadingTimeoutEvent: ReturnType<typeof setTimeout>;
  hasSubscription = false;
  emitted = false;
  subscription: Subscription;

  constructor(private router: Router) {}

  onInit() {
    this.router.events.forEach((event) => {
      if (event instanceof NavigationStart) {
        // Clear any pending timeout and teardown any previous navigation subscription
        if (this.loadingTimeoutEvent) {
          clearTimeout(this.loadingTimeoutEvent);
        }
        if (this.subscription) {
          this.teardownPreviousSubscription();
        }

        // Start a new delayed spinner emission
        this.startLoadingTimeout();
      } else if (event instanceof NavigationEnd || event instanceof NavigationCancel || event instanceof NavigationError) {
        // Cancel pending spinner timeout and hide spinner if it was emitted
        this.cancelLoadingTimeoutAndMaybeHideSpinner();
      }
    });
  }

  private teardownPreviousSubscription(): void {
    this.emitSpinner(false);
    try {
      this.subscription.unsubscribe();
    } catch {
      // ignore unsubscribe errors
    }
    this.hasSubscription = false;
  }

  private startLoadingTimeout(): void {
    this.loadingTimeoutEvent = setTimeout(() => {
      this.emitSpinner(true);
    }, 1000);
  }

  private cancelLoadingTimeoutAndMaybeHideSpinner(): void {
    clearTimeout(this.loadingTimeoutEvent);
    if (!this.hasSubscription && this.emitted) {
      this.emitSpinner(false);
    }
  }

  onPageEvent(next: (value: boolean) => void): Subscription {
    return this.pageEvent$.subscribe(next);
  }

  showSpinnerForDataLoading(subscription: Subscription, delayInMilliseconds = 0): void {
    this.hasSubscription = true;
    this.emitSpinner(true);
    subscription.add(() => {
      setTimeout(() => {
        this.emitSpinner(false);
      }, delayInMilliseconds);
    });
  }

  forceCloseSpinner(): void {
    this.emitSpinner(false);
  }

  private emitSpinner(visible: boolean): void {
    this.pageEvent$.emit(visible);
    this.emitted = visible;
  }
}
